import { DotLottie } from "@lottiefiles/dotlottie-web";

export default {
    name: 'lottie',
    component() {
        return {
            init() {
                let heroDog = this.$el.querySelector("#hero-dog");
                let heroCat = this.$el.querySelector("#hero-cat");
                let catFaq = this.$el.querySelector("#cat-faq");
                let catTestimonials = this.$el.querySelector("#cat-testimonials");
                let catFaqPage = this.$el.querySelector("#cat-faq-page");
                let dogCollections = this.$el.querySelector("#dog-collections-top");
                let catCollections = this.$el.querySelector("#cat-collections-top");
                let dogCollectionsBottom = this.$el.querySelector("#dog-collections-bottom");
                let catCollectionsBottom = this.$el.querySelector("#cat-collections-bottom");
                let dogInsta = this.$el.querySelector("#dog-insta");
                let dogStores = this.$el.querySelector("#dog-stores");
                let dogForm = this.$el.querySelector("#dog-form");
                let dogHighlights = this.$el.querySelector("#dog-highlights");
                let catContact = this.$el.querySelector("#cat-contact");

                this.setLottie(heroDog, 1, [0, 0.5], false);
                this.setLottie(heroCat, 0.75, [1, 0.5], false);
                this.setLottie(catFaq, 1, [1, 0.5], false);
                this.setLottie(catTestimonials, 1, [0, 0.5], true);
                this.setLottie(catFaqPage, 1, [1, 1], true);
                this.setLottie(dogCollections, 0.6, [1, 0.5], false);
                this.setLottie(catCollections, 0.6, [0, 0.5], false);
                this.setLottie(dogCollectionsBottom, 0.5, [1, 0.5], true);
                this.setLottie(catCollectionsBottom, 0.5, [1, 0.5], true);
                this.setLottie(dogInsta, 1, [1, 0.5], false);
                this.setLottie(dogStores, 0.8, [1, 0.5], true);
                this.setLottie(dogForm, 0.5, [1, 0.5], false);
                this.setLottie(dogHighlights, 1, [1, 0.5], true);
                this.setLottie(catContact, 1, [1, 0.5], true);
            },

            setLottie(target, speed, align, looping) {
                if (target == null) return;

                const lottie = new DotLottie({
                    autoplay: false,
                    loop: looping,
                    canvas: target,
                    speed: speed,
                    src: target.dataset.lottie,
                    layout: {
                        fit: "fit-height",
                        align: align,
                    },
                });

                lottie.addEventListener("load", () => {
                    const observer = new IntersectionObserver(
                        (entries) => {
                            entries.forEach((entry) => {
                                if (entry.isIntersecting) {
                                    setTimeout(() => {
                                        lottie.play();
                                    }, 50);
                                    observer.unobserve(target);
                                }
                            });
                        },
                        { threshold: 0.1 }
                    );

                    observer.observe(target);
                });

            }
        }
    }
}